const SCROLLABLE_CLASS = "sticky-options-scrollable";

export const observeStickyOptionsShadow = (scroller) => {
  const toggleShadow = () => {
    scroller.classList.toggle(
      SCROLLABLE_CLASS,
      scroller.scrollLeft + scroller.clientWidth < scroller.scrollWidth - 1
    );
  };
  const resizeObserver = new ResizeObserver(toggleShadow);

  scroller.addEventListener("scroll", toggleShadow, { passive: true });
  resizeObserver.observe(scroller);

  return () => {
    scroller.removeEventListener("scroll", toggleShadow);
    resizeObserver.disconnect();
  };
};

const toggleViewportShadows = () => {
  document.querySelectorAll(".sticky-options-viewport").forEach((frame) => {
    frame.classList.toggle(
      SCROLLABLE_CLASS,
      frame.getBoundingClientRect().right >
        document.documentElement.clientWidth + 1
    );
  });
};

const pinOptionsMenu = (event) => {
  const group = event.currentTarget;
  if (!(group instanceof Element)) return;
  const column = group.closest(".sticky-options-col");
  if (!column) return;

  column.style.zIndex = "1000";
  $(group).one("hidden.bs.dropdown", () => {
    column.style.zIndex = "";
  });
};

export const initStickyOptionsColumns = () => {
  $(document).on(
    "shown.bs.dropdown",
    ".sticky-options-col .btn-group",
    pinOptionsMenu
  );
  window.addEventListener("scroll", toggleViewportShadows, { passive: true });
  window.addEventListener("resize", toggleViewportShadows);
  document.addEventListener("turbolinks:load", toggleViewportShadows);
};
